import React from 'react';

const MainContainerQueryContext = React.createContext();

export const MainContainerQueryConsumer = MainContainerQueryContext.Consumer;

export const MainContainerQueryProvider = (props) => {

    const { children, matches } = props;

    if (!children) {

        return null;

    }

    return (
        <MainContainerQueryContext.Provider value={matches}>
            {children}
        </MainContainerQueryContext.Provider>
    );

};

export const useMainContainerQueryContext = () => {

    return React.useContext(MainContainerQueryContext);

};
